export default {"src":"/_next/static/media/chat_gpt.76da3d00.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};